var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-print hidden-xs hidden-sm"},[_c('nav',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.checkScroll),expression:"checkScroll"}],staticClass:"bs-docs-sidebar",class:{affix:_vm.affixed},style:({top:_vm.top})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a81768a","hasScoped":false,"buble":{"transforms":{}}}!./src/affix/template.html
// module id = 144
// module chunks = 0